import React from 'react';

import { connect } from 'react-redux';
import { selectors as dashboardSelectors } from '../../state/modules/dashboards';
import { selectors as groupSelectors } from '../../state/modules/groups';
import { selectors as skillSelectors } from '../../state/modules/skills';
import { selectors as taskSelectors } from '../../state/modules/tasks';
import { selectors as dutyFunctionSelectors } from '../../state/modules/standby-duty-functions';
import { loading as combinedSchedulesLoading } from '../../state/modules/combined-schedules/selectors';
import { selectors as userSelectors } from '../../state/modules/users';
import { selectors as membershipSelectors } from '../../state/modules/memberships';
import ErrorBoundary from '../general/ErrorBoundary';
import './DashboardLoadingStatus.css';

const DashboardLoadingStatus = ({
  dashboardLoadingStatus,
  groupsLoadingStatus,
  combinedSchedulesLoadingStatus,
  skillsLoadingStatus,
  tasksLoadingStatus,
  dutyFunctionsLoadingStatus,
  usersPaginationStatus,
  membershipsPaginationStatus,
  usersErrorStatus,
  membershipsErrorStatus
}) => {
  const loadingItems = {
    nonPaginated: [
      {
        key: 'dashboards',
        loading: dashboardLoadingStatus,
        translation: I18n.t('activerecord.models.dashboards/dashboard')
      },
      {
        key: 'groups',
        loading: groupsLoadingStatus,
        translation: I18n.t('activerecord.models.group')
      },
      {
        key: 'combinedSchedules',
        loading: combinedSchedulesLoadingStatus,
        translation: I18n.t('activerecord.models.schedule/combined_schedule')
      },
      {
        key: 'skills',
        loading: skillsLoadingStatus,
        translation: I18n.t('activerecord.models.skill')
      },
      {
        key: 'tasks',
        loading: tasksLoadingStatus,
        translation: I18n.t('activerecord.models.task')
      },
      {
        key: 'dutyFunctions',
        loading: dutyFunctionsLoadingStatus,
        translation: I18n.t('activerecord.models.standby_duty_function')
      }
    ],
    paginated: [
      {
        key: 'users',
        pagination: usersPaginationStatus,
        translation: I18n.t('activerecord.models.user'),
        error: usersErrorStatus
      },
      {
        key: 'memberships',
        pagination: membershipsPaginationStatus,
        translation: I18n.t('activerecord.models.membership'),
        error: membershipsErrorStatus
      }
    ]
  };

  // don't show loading status if nothing is loading
  if (
    !loadingItems.nonPaginated.some(item => item.loading) &&
    !loadingItems.paginated.some(item => item.pagination.loading)
  ) {
    return null;
  }

  for (const item of loadingItems.paginated) {
    if (typeof item.translation !== 'string') {
      item.translation = item.translation.other;
    }
  }

  for (const item of loadingItems.nonPaginated) {
    if (typeof item.translation !== 'string') {
      item.translation = item.translation.other;
    }
  }

  return (
    <ErrorBoundary>
      <div className="loading-status-container">
        {loadingItems['nonPaginated']
          .filter(i => i.loading)
          .map(item => (
            <div key={item.key} className="loading-status-bullet">
              {I18n.t('loading')} {item.translation}
              ...
            </div>
          ))}
        {loadingItems['paginated'].map(item => {
          const { percentage, error } = item.pagination;

          const text = error ? error.statusText : Number.isNaN(percentage) ? '0' : Math.floor(percentage);

          if ((item.pagination.loading && Number.isNaN(percentage)) || percentage < 100) {
            return (
              <div key={item.key} className="loading-status-bullet">
                {I18n.t('loading')} {item.translation} ({text} %)
              </div>
            );
          }
        })}
      </div>
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  // Not paginated
  dashboardLoadingStatus: dashboardSelectors.loading(state),
  groupsLoadingStatus: groupSelectors.loading(state),
  combinedSchedulesLoadingStatus: combinedSchedulesLoading(state),
  skillsLoadingStatus: skillSelectors.loading(state),
  tasksLoadingStatus: taskSelectors.loading(state),
  dutyFunctionsLoadingStatus: dutyFunctionSelectors.loading(state),
  // Paginated
  usersPaginationStatus: userSelectors.paginationInfo(state),
  membershipsPaginationStatus: membershipSelectors.paginationInfo(state),
  // Errors
  usersErrorStatus: userSelectors.error(state),
  membershipsErrorStatus: membershipSelectors.error(state)
});

export default connect(mapStateToProps)(DashboardLoadingStatus);
